import { ROLES } from '../../../../_configuration';
import { IColumnFloors } from '../../_core/_ui/simple-table.types';

export const DEFAULT_ASSESSMENT_MEMBER_ROLES = [ROLES.CHECK_IN]
// Assessment roles that don't pull DEFAULT_ASSESSMENT_MEMBER_ROLES on when granted.
export const ROLES_WITHOUT_DEFAULT_ASSESSMENT_ROLES = [ROLES.CHECK_IN, ROLES.SCORING]
// Assessment-level roles the age-group table shows read-only beside its own columns.
export const ASSESSMENT_ONLY_AGE_GROUP_COLUMNS = [ROLES.CHECK_IN, ROLES.SCORING]

// The User column stacks name over email, so it floors wider than SimpleTable's default first column.
export const USER_TABLE_COLUMN_FLOORS: IColumnFloors = { first: 260 };
